<template>
  <div>
    <el-collapse :value="['1']">
      <el-collapse-item title="分享按钮" name="1">
        <draggable element="ul" v-model="itemList" handle=".mover" ghost-class="ghost" chosen-class="chosen"
          @start="startDrag" @end="endDrag" filter=".disabled">
          <li class="menu-item verticallyCenter" v-for="(item, index) in itemList" :key="index">
            <i class="mover icondrag icon-portal-drag" :class="dragging ? 'dragging' : ''"></i>
            <div class="td">
              <div class="btnIcon" v-if="item.iconType === 'icon'" v-html="item.svg"></div>
              <img :src="item.iconSrc || defaultImage" alt="" class="btnIcon" v-if="item.iconType === 'img'" />
            </div>
            <div class="td text" :class="!item.isShow ? 'hide' : ''">
              <span class="overflowHid2">{{ item.name }}</span>
            </div>
            <div class="td">
              <span class="edit icon-portal-preview-open" v-if="item.isShow" @click="handleCommandShow(item, index, false)"></span>
              <span class="edit icon-portal-preview-close" v-else @click="handleCommandShow(item, index, true)"></span>
              
              <el-tooltip class="item" effect="dark" content="编辑" placement="top" :open-delay="1000"><span
                  class="edit icon-portal-edit-1" @click.stop="handleCommandEdit(item, index)"></span></el-tooltip>
            </div>
          </li>
        </draggable>
        <div v-show="showBgSetDialog" ref="shareBgWrap">
          <tabs-img-upload-dialog
            v-if="tabsItem"
            :tabsItem="tabsItem"
            :tabsActiveIndex="tabsActiveIndex"
            @addImg="closeBgSetDialog"
            updateName="itemList"
          ></tabs-img-upload-dialog>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import defaultImgSrc from "../../../assets/images/image_placeholder.png"
import draggable from "vuedraggable"
import tabsImgUploadDialog from "@/materials/tabs/toolbars/tabsImgUploadDialog.vue"
import { simpleDeepClone } from "../../../utils"

export default {
  components: {
    draggable,
    tabsImgUploadDialog
  },
  props: {
    myid: {
      type: Object,
      default: () => { },
    },
    options: {
      default: () => { },
      type: Object
    }
  },
  data() {
    return {
      showEditIndex: null,
      defaultImage: defaultImgSrc,
      dragging: false,
      tabsItem: null,
      tabsActiveIndex: 0,
      showBgSetDialog: false
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    itemList: {
      get() {
        return this.options.itemList.map(item => {
          if (item.iconType === 'icon') {
            item.svg = this.getSvgContent(item.iconSrc)
          }
          if (item.activeIconType === 'icon') {
            item.activeSvg = this.getSvgContent(item.activeIconSrc)
          }
          if (item.hoverIconType === 'icon') {
            item.hoverSvg = this.getSvgContent(item.hoverIconSrc)
          }
          return item
        })
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "itemList", false)
      }
    }
  },
  mounted() {
    document.getElementById("app").addEventListener("click", this.hidder, true)
  },
  beforeDestroy() {
    document.getElementById("app").removeEventListener("click", this.hidder, true)
  },
  methods: {
    getSvgContent(encrypt) {
      if (!!encrypt) {
        let svgContent = this.$store.state.states.iconSvg
        if (svgContent && svgContent.hasOwnProperty(encrypt)) {
          return svgContent[encrypt]
        }
        if (!svgContent || !svgContent.hasOwnProperty(encrypt)) {
          this.$store.commit("states/updateSvg", {
            svgId: encrypt,
            value: ""
          })
        }
        this.instance.get(this.contextPath + `v2/svg/${encrypt}`).then(res => {
          if (res.status === 200) {
            return res.data
          }
        })
      } else {
        return ""
      }
    },
    startDrag(e) {
      this.dragging = true
    },
    endDrag(e) {
      this.dragging = false
      const param = {
        ...this.ids,
        option_name: "itemList",
        option_val: this.itemList
      }
      this.$store.dispatch(this.request_prefix + "/changeOptions", param)
    },
    handleCommandEdit(item, index) {
      this.showBgSetDialog = true
      this.tabsActiveIndex = index
      this.tabsItem = simpleDeepClone(item)      
    },
    handleCommandShow(item, index, type) {
      let result = JSON.parse(JSON.stringify(item))
      result.isShow = type
      const param = {
        ...this.ids,
        option_name: `itemList.${index}`,
        option_val: result
      }
      this.$store.dispatch(this.request_prefix + "/changeOptions", param)
    },
    closeBgSetDialog() {
      this.showBgSetDialog = false
    },
    hidder(e) {
      let ele = this.$refs.shareBgWrap?.querySelector(".bg-set-dialog")
      if (ele && ele.contains(e.target)) {
        return
      } else {
        this.showBgSetDialog = false
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.menu-item {
  position: relative;
  min-height: 32px;
  border-radius: 4px;
  margin-top: 8px;
  font-size: 14px;
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }

  &:first-child {
    margin-top: 0;
  }

  .td {
      height: 100%;
      display: flex;
      align-items: center;
      text-align: left;
      font-size: 13px;
      line-height: 18px;
      &.text {
        flex: 1;
        color: rgba(0, 0, 0, 0.8);
        font-size: 13px;
        &.hide {
          color: rgba(0, 0, 0, 0.4);
        }
      }

      .btnIcon {
        width: 20px;
        height: 20px;
        object-fit: cover;
      }
      
      .edit {
        width: 24px;
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
        border-radius: 4px;
        margin-left: 4px;
        &:hover {
          background: rgba(0, 0, 0, 0.05);
        }
      }
    }

  .icondrag {
    color: var(--fourthTextColor);
    margin-right: 6px;
    font-size: 14px;

    &:not(.disabled):hover {
      color: var(--themeColor);
      cursor: grab;
    }

    &.dragging {
      cursor: grabbing;
    }

    &.disabled {
      cursor: not-allowed;
    }
  }

  .edit-box {
    display: inline-block;

    input {
      box-shadow: inset 0px 0px 0px 2px var(--themeColor);
      border-radius: 4px;
      background: transparent;
      width: 106px;
      height: 28px;
      padding: 5px 8px;
    }

    i {
      line-height: 28px;
      display: inline-block;
      vertical-align: top;
      color: var(--themeColor);
      font-size: 20px;
      margin-left: 6px;
      cursor: pointer;
    }
  }
}
::v-deep svg {
  width: 100%;
  height: 100%;
}

::v-deep .ghost::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 100%;
  height: 2px;
  background: var(--themeColor);
}
</style>